<template>
  <div>
    <error v-if="view == views.error" :error_msg="error_msg"></error>
    <asta v-else-if="view == views.asta"></asta>
    <splash v-else></splash>
  </div>
</template>

<script>
import ge from "../../js/globalEvent";
import db from "../../js/db";
import Asta from "../Asta.vue";
import Error from "./Error";
import Splash from "./Splash";
import Reset from "./Reset";
import Vuex from "vuex";
import { ErrorAstaNotFound, ErrorSessionExist } from "../../js/errors";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";

export default {
  name: "Main",
  components: { Asta, Error, Splash, Reset },
  mixins: [mixins],
  data() {
    return {
      error_msg: "",
      views: { splash: "splash", error: "error", asta: "asta" },
      view: null,
      idleJs: null,
    };
  },
  mounted() {
    console.log("--> Main ready.");
    window.addEventListener("beforeunload", this.promptBeforeExit);
    ge.on("fetchedVersion", this.handleVersion);
    this.initAsta();
  },
  destroyed() {
    console.log("<-- Main destroyed.");
    window.removeEventListener("beforeunload", this.promptBeforeExit);
    this.stopIdle();
    ge.off("fetchedVersion", this.handleVersion);
  },
  computed: {
    // stateLoaded() {
    //   return !this.isEmpty(this.asta_squadre);
    // },

    ...Vuex.mapGetters(["version"]),
  },
  watch: {
    my_squadra(squadra, precedente) {
      if (this.Config.STANDALONE && this.view === this.views.asta && precedente && !squadra) {
        this.handleSquadraEliminata();
      }
    },
  },
  methods: {
    handleSquadraEliminata() {
      this.view = this.views.splash;
      this.warnBeforeUnload = false;
      this.stopIdle();
      db.leavePresence().catch(console.error);
      this.$router.replace("/");
      Swal.fire({
        icon: "info",
        title: "Squadra non presente",
        text: "La tua squadra non fa più parte di questa asta. Puoi iscriverti nuovamente usando l'invito e creando una nuova squadra.",
      });
    },
    startIdle() {
      if (this.idleJs) {
        this.idleJs.start();
      }
    },
    stopIdle() {
      if (this.idleJs) {
        this.idleJs.stop();
      }
    },
    initAsta() {
      // occhio: _id_asta è l'input esterno, asta_id è il valore nello stato
      // serve leggere anche da firebase perchè <Main> è accessibile anche in '/'
      // todo:  _id_asta in component.data
      let _id_asta = window.firebase
        ? window.firebase.id_asta
        : this.$route.params.id;

      // 1) mostra splash
      this.view = this.views.splash;
      // 2 committa subito AstaInfo nello state
      // (perchè tutti i listener FirebaseRef hanno bisogno di getters.asta_id nn vuoto)
      this.$store
        .dispatch("setAstaInfo", _id_asta)
        .then(() => {
          return db.initPresence();
        })
        .then(() => {
          this.idleJs = db.initIdle();
        })
        .then(() => {
          this.startIdle();
        })
        // listoneConf è "once"
        .then(() => {
          return this.$store.dispatch("setListoneConf").catch((err) => {
            if (!Helpers.isLocalRuntime()) {
              throw err;
            }
            console.warn(
              "Listone conf non disponibile in questo ambiente.",
              err
            );
          });
        })
        // 3) calciatori è "once"
        .then(() => {
          return this.$store.dispatch("setCalciatoriOriginal");
        })
        .then(() => {
          // setMainStatus deve stare dopo che "calciatori" è disponibile
          // perchè non deve aggiungere nid di anni passati (vd mutation CALCIATORI_MAIN_STATUS)
          return this.$store.dispatch("setMainStatus");
        })
        // initAnnoStats deve stare dopo che "calciatori" è disponibile
        .then(() => {
          return this.initAnnoStats();
        })
        // serve perchè in checkAllineamentoRose uso asta_squadre
        // serve anche per pianificazione
        .then(() => {
          return this.$store.dispatch("setSquadre");
        })
        // TBD se serve davvero setAstaRound
        .then(() => {
          return this.$store.dispatch("setAstaRound");
        })
        .then(() => {
          return this.$store.dispatch("setVersion");
        })
        .then(() => {
          return this.$store.dispatch("fetchLegaInfo");
        })
        // 4) una volta salvato posso far partire gli altri listener
        .then(() => {
          ge.fetchVersion();
          if (this.Config.STANDALONE && !this.my_squadra) {
            this.handleSquadraEliminata();
            return;
          }
          this.view = this.views.asta;
        })
        .catch((err) => {
          if (err instanceof ErrorAstaNotFound) {
            this.error_msg = err.message;
            this.view = this.views.error;
          } else if (err instanceof ErrorSessionExist) {
            // this.view = this.views.reset;
            this.$router.push({
              path: "/reset",
              query: { asta_id: this.asta_id, type: "sessionExists" },
            });
          } else {
            console.log("err", err);
            throw err;
          }
        });
    },

    handleVersion(version) {
      if (this.version && version != this.version) {
        this.propmtNewVersion(version);
      }
    },
    propmtNewVersion(version) {
      Swal.fire({
        title: "Aggiornamento disponibile",
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "Aggiorna alla " + version,
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.warnBeforeUnload = false;
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../main.scss";

main {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 500px;
}
</style>
